export default defineNuxtRouteMiddleware(async (to, from) => {
  const storeOoloja = useStoreOoloja();
  const user = useUserStore();

  if (process.server) return;

  let _path = to.path.split("/").filter((item) => item)[0];

  if (_path === 'ooloja') {
    let dataAtualizado = storeOoloja.configuracoes.atualizado;
    if (dataAtualizado === null)
      storeOoloja.setConfiguracoes({ atualizado: new Date().getTime() });

    let dataAgora = new Date().getTime();
    let diferenca = dataAgora - dataAtualizado;
    let dezMinutos = 1000 * 60 * 0;

    // console.log(dezMinutos / 1000 / 60 / 10)
    // console.log(diferenca - dezMinutos);

    if (diferenca > dezMinutos) {
      console.info('Atualizando...');

      await useAPI.get('/ooloja/get-configs/?ac=configuracoes&or=admin&0=produto_|erp_|bot_', user.user.token).then((response) => {

        let configuracoes = response.data;

        let produtoEstoque = configuracoes.find((item) => item.option == 'produto_estoque').value == '1' ? true : false;
        let produtoEstoqueBloqueiaVenda = configuracoes.find((item) => item.option == 'erp_produto_compra_fora_estoque').value == '1' ? true : false;
        let bot_on = configuracoes.find((item) => item.option == 'bot_chatbot_on').value == '1' ? true : false;
        let bot_produto_descricao_on = configuracoes.find((item) => item.option == 'bot_produto_descricao_on').value == '1' ? true : false;

        let condicoes_parcelamento_status = configuracoes.find((item) => item.option == 'erp_condicoes_parcelamento').value == '1' ? true : false;

        storeOoloja.setConfiguracoes({
          atualizado: new Date().getTime(),
          produto_estoque: produtoEstoque,
          produto_estoque_bloqueia_venda: produtoEstoqueBloqueiaVenda,
          condicoes_parcelamento_status: condicoes_parcelamento_status,
          // erp_on: erpPSiOn,
          bot_on: bot_on,
          bot_produto_descricao_on: bot_produto_descricao_on
        });

      });

      //Carrega o status de Condicoes de Parcelamento para o store
      await useAPI.get("fseo/", user.user.token, { "status": true }).then((response) => {
        storeOoloja.setCondicoesParcelamentoStatus(response.data ?? false);
      })
    }
  }

  // return null;
});
